// The one place the decoupled On/Off + Always/Scheduled model is turned into a single state.
//
// Both surfaces that render a row read it: the main settings row and the Active Tools sidebar
// mirror. They key their CSS off the same status class, so keeping the precedence here stops the
// two from drifting apart — a tool that reads Scheduled in one place and Active in the other.
export const STATUS = { ACTIVE: 'Active', SCHEDULED: 'Scheduled', INACTIVE: 'Inactive' };

const STATUS_CLASSES = {
  [STATUS.ACTIVE]: 'status-active',
  [STATUS.SCHEDULED]: 'status-scheduled',
  [STATUS.INACTIVE]: 'status-inactive',
};

// On wins over a window: a tool that is both active and scheduled is running Always, with the
// window merely remembered. Scheduled means the window is what's running it.
export function statusFor({ active, schedule }) {
  if (active === true) return STATUS.ACTIVE;
  if (schedule) return STATUS.SCHEDULED;
  return STATUS.INACTIVE;
}

export function applyStatusClass(element, status) {
  element.classList.remove(...Object.values(STATUS_CLASSES));
  element.classList.add(STATUS_CLASSES[status]);
}
